/* eslint-disable max-len */
import * as React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const Pen = (props: Props) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3553_13435)">
      <path
        d="M11.9667 3.39888L12.7391 2.62648C14.0188 1.34673 16.0937 1.34673 17.3735 2.62648C18.6532 3.90623 18.6532 5.98113 17.3735 7.26088L16.6011 8.03328M11.9667 3.39888C11.9667 3.39888 12.0632 5.04023 13.5115 6.48848C14.9597 7.93673 16.6011 8.03328 16.6011 8.03328M11.9667 3.39888L4.86565 10.4999C4.38468 10.9809 4.14419 11.2214 3.93737 11.4865C3.69341 11.7993 3.48424 12.1378 3.31358 12.4959C3.1689 12.7994 3.06136 13.1221 2.84626 13.7674L2.1576 15.8333L1.9348 16.5017M16.6011 8.03328L9.50004 15.1343C9.01908 15.6153 8.77859 15.8558 8.51343 16.0626C8.20064 16.3066 7.8622 16.5157 7.50411 16.6864C7.20054 16.8311 6.8779 16.9386 6.23261 17.1537L4.16663 17.8424L3.49823 18.0652M3.49823 18.0652L2.82983 18.288C2.51228 18.3938 2.16217 18.3112 1.92549 18.0745C1.6888 17.8378 1.60615 17.4877 1.712 17.1701L1.9348 16.5017M3.49823 18.0652L1.9348 16.5017"
        stroke={props.color ?? props?.style?.color}
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_3553_13435">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Pen;
